"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[468],{

/***/ 45043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useDiscoverySearchV2; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93369);


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearchV2 = (discoveryService, params, configs) => {
  const _a = configs || {}, { transform = (data2) => data2 } = _a, swrConfigs = __objRest(_a, ["transform"]);
  const { data, error } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(params && Object.keys(params).length ? [params, "discovery-search-v2"] : null, async (params2) => {
    const response = await discoveryService.search(params2);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  return {
    result: data,
    error,
    loading: !error && !data
  };
};




/***/ }),

/***/ 31844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useInfiniteDiscoverySearchV2; }
/* harmony export */ });
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62176);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useInfiniteDiscoverySearchV2 = (discoveryService, params, configs) => {
  var _b, _c;
  const _a = configs || {}, {
    transform = (data2) => data2
  } = _a, swrConfigs = __objRest(_a, [
    "transform"
  ]);
  const { data, size, setSize, isValidating, error } = (0,swr_infinite__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((page) => [
    __spreadProps(__spreadValues({}, params), { page: page + 1 }),
    "discovery-search-v2"
  ], async (payload) => {
    const response = await discoveryService.search(payload);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  const isEmpty = data && ((_b = data[0].products) == null ? void 0 : _b.length) === 0;
  const hasMore = (((_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.total) || 0) > size * ((params == null ? void 0 : params.pageSize) || 10);
  const loadmore = () => {
    setSize((page) => page + 1);
  };
  return {
    loading: isValidating,
    hasMore,
    data,
    loadmore,
    size,
    isEmpty: !!isEmpty,
    error
  };
};




/***/ }),

/***/ 97441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eo": function() { return /* binding */ cookDiscoveryFilter; },
/* harmony export */   "Ot": function() { return /* binding */ transformBlock; },
/* harmony export */   "Zj": function() { return /* binding */ getBlockDomId; },
/* harmony export */   "jx": function() { return /* binding */ convertObjectDiscoveryToQueryStringSearch; },
/* harmony export */   "yA": function() { return /* binding */ findBlockByType; }
/* harmony export */ });
/* unused harmony exports fetchSingleDataBlockSSR, fetchSingleDataBlockSSRFromDiscoveryV2, fetchDataBlockSSR, fetchDataBlockSSRFromDiscoveryV2 */
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89172);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20577);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31260);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








const listingAndDiscoveryKeysMap = {
    priceGte: "price_gte",
    priceLte: "price_lte"
};
const listingAndDiscoveryValuesMap = {
    ORDER_BY_DESCENDING: "DESC",
    ORDER_BY_ASCENDING: "ASC"
};
const convertObjectDiscoveryToQueryStringSearch = (params)=>{
    if (!params) return "/";
    const newParams = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)(_objectSpreadProps(_objectSpread({}, params), {
        router: "productListing"
    }));
    return "/search?" + Object.keys(newParams).map((key)=>{
        if (!newParams[key] || Array.isArray(newParams === null || newParams === void 0 ? void 0 : newParams[key]) && newParams[key].length === 0) {
            return;
        }
        return (listingAndDiscoveryKeysMap[key] || key) + "=" + (listingAndDiscoveryValuesMap[newParams[key]] || newParams[key]);
    }).filter((query)=>query).join("&");
};
const cookDiscoveryFilter = (filter)=>{
    if (!filter) return {};
    if (filter === null || filter === void 0 ? void 0 : filter.attributes.length) {
        filter.attributes.map((el)=>filter["attributes.".concat(el.code)] = el.optionIds.join());
        const { attributes: tbr  } = filter, newFilter = _objectWithoutProperties(filter, [
            "attributes"
        ]);
        return newFilter;
    }
    return filter;
};
const findBlockByType = (type, blocks)=>{
    return blocks && blocks.find((block)=>block.type === type);
};
const getUrl = (item)=>{
    var ref;
    const { url , redirectUrl , params  } = item || {};
    return redirectUrl ? redirectUrl : url || convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter), ((ref = item.params) === null || ref === void 0 ? void 0 : ref.sorting) || {}));
};
const getLinkHref = (url, paramsObject, title)=>{
    let href = null;
    if (url) {
        if (url.startsWith("/landing/")) {
            href = {
                pathname: "/landing/[id]",
                query: {
                    id: url.substring("/landing/".length)
                }
            };
        } else {
            href = url;
        }
    } else {
        // remove non-relevant flags from paramsObject
        // such as false param or empty array
        // we don't want them to appear on browser url
        /**
     *
     *  "sellingCodes": [],
        "priceLte": "0",
        "priceGte": "0",
        "brands": [],
        "flashSaleType": "",
        "masterCategories": [],
        "excludedSkus": [],
        "masterCategoryIds": [62],
      }
     */ const queryParams = {};
        for (const [key, value] of Object.entries(paramsObject)){
            if (value && (!Array.isArray(value) || value.length > 0) && (isNaN(value) || !!parseInt(value))) {
                queryParams[key] = value;
            }
        }
        href = {
            pathname: "/search",
            query: _objectSpreadProps(_objectSpread({}, queryParams), {
                pageTitle: title,
                router: "productListing"
            })
        };
    }
    return {
        href
    };
};
const transformBlockItemTypeSku = (block)=>{
    const { fetchParams , collectionSlug =""  } = block.content;
    block.cookedData = {
        queryString: convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter), fetchParams.sorting)),
        paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)({
            filter: collectionSlug ? undefined : cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter),
            sorting: collectionSlug ? {} : (fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.sorting) || {},
            slug: collectionSlug,
            blockId: block.id
        })
    };
    return block;
};
const transformBanner = (block)=>{
    const banners = block.content.items.map((item)=>{
        var ref, ref1;
        const paramsObject = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)(_objectSpreadProps(_objectSpread({}, cookDiscoveryFilter(item === null || item === void 0 ? void 0 : (ref = item.params) === null || ref === void 0 ? void 0 : ref.filter), ((ref1 = item.params) === null || ref1 === void 0 ? void 0 : ref1.sorting) || {}), {
            blockId: block.id,
            itemId: item.id
        }));
        return {
            id: item.id,
            targetPath: getUrl(item),
            image: item.imageUrl,
            campaignName: item.label,
            description: item.subLabel,
            paramsObject,
            url: item.url,
            thumbnail: item.thumbnail,
            link: getLinkHref(item.url || item.redirectUrl || "", paramsObject, item.label),
            imageSize: item.imageSize
        };
    });
    block.cookedData = banners || [];
    return block;
};
const transformBlockMixBanner = (block)=>{
    var ref, ref1;
    const firstItem = block === null || block === void 0 ? void 0 : (ref = block.content) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0];
    const trackingRegionName = "categoriesBlockBrand";
    block.cookedData = {
        header: {
            title: block.label,
            link: {
                href: getUrl(firstItem)
            }
        },
        banner: {
            src: firstItem.imageUrl,
            alt: firstItem.label || firstItem.subLabel,
            tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: trackingRegionName,
                contentName: firstItem.label,
                target: getUrl(firstItem)
            }),
            link: {
                href: getUrl(firstItem)
            }
        },
        contentItems: block.content.items.slice(1, 5).map((category)=>({
                name: category.label,
                description: category.subLabel,
                image: {
                    src: category.imageUrl,
                    alt: category.label || category.subLabel
                },
                link: {
                    href: getUrl(category)
                }
            })),
        bottomImages: block.content.items.slice(5, 11).map((brand, index)=>({
                src: brand.imageUrl,
                alt: brand.label || brand.subLabel,
                tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: trackingRegionName,
                    contentName: brand.label,
                    index,
                    target: getUrl(brand)
                }),
                link: {
                    href: getUrl(brand)
                }
            }))
    };
    return block;
};
const transformBlockHotDeal = (block)=>{
    block.cookedData = block.content.items.map((el)=>{
        const { collectionSlug , params , id  } = el;
        return _objectSpreadProps(_objectSpread({}, el), {
            name: el.label,
            url: el.redirectUrl || el.url,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
    });
    return block;
};
const transformBlockListingTab = (block)=>{
    const categoryList = [];
    block.content.items.forEach((item)=>{
        const { collectionSlug , params , id  } = item;
        const obj = _objectSpreadProps(_objectSpread({}, item), {
            id: item.id,
            name: item.label,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
        categoryList.push(obj);
    });
    block.cookedData = categoryList;
    return block;
};
const transformBlock = (block)=>{
    if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.SKU */ .Nc.SKU) return transformBlockItemTypeSku(block);
    else if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.BANNER */ .Nc.BANNER || [
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_HIGHLIGHTED_BANNER */ .kH.HORIZONTAL_HIGHLIGHTED_BANNER,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_CATEGORY */ .kH.RECOMMENDED_CATEGORY,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_BRANDS */ .kH.RECOMMENDED_BRANDS,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.PROMOTE_CATEGORY_MENU */ .kH.PROMOTE_CATEGORY_MENU,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_2_BANNER_MOBILE */ .kH.HORIZONTAL_2_BANNER_MOBILE, 
    ].includes(block.type)) return transformBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER) return transformBlockMixBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_TAB_MOBILE */ .kH.COUNT_DOWN_PROMO_TAB_MOBILE) return transformBlockHotDeal(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.LISTING_TAB */ .kH.LISTING_TAB) return transformBlockListingTab(block);
    else return block;
};
const fetchSingleDataBlockSSR = async function(context, block) {
    let includeFilter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, optionnalFilterParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref;
    const { req , query  } = context;
    const { tenantEnv , location , isMobile  } = req;
    const { discoveryService , discoveryHelper  } = new ServiceContainer(tenantEnv);
    const filterParams = _objectSpread({}, block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref.paramsObject, optionnalFilterParams);
    const variables = _objectSpreadProps(_objectSpread({}, cleanObject(filterParams)), {
        location: location
    });
    try {
        var ref1, ref2;
        const [{ result  }, { result: resultFilter  }] = await Promise.all([
            discoveryService.search(_objectSpreadProps(_objectSpread({}, variables, cleanObject(query)), {
                itemsPerPage: isMobile ? DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE : MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE
            })),
            includeFilter ? await discoveryService.search(_objectSpreadProps(_objectSpread({}, variables), {
                itemsPerPage: 1,
                returnFilterable: [
                    "FILTER_TYPE_BRAND",
                    "FILTER_TYPE_PRICE",
                    "FILTER_TYPE_ATTRIBUTE",
                    "FILTER_TYPE_CLEARANCE", 
                ]
            })) : {
                result: null
            }, 
        ]);
        return {
            products: (result === null || result === void 0 ? void 0 : result.products) || [],
            ssrProducts: ((result === null || result === void 0 ? void 0 : result.products) || []).map((product)=>discoveryHelper.cleanupDiscoverySearchProduct(product)),
            filters: (resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter) ? cookFilter(resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter, normalizePageBuilderToDiscoveryParams(variables), resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.masterCategories) : null,
            filterPrice: {
                max: Number(resultFilter === null || resultFilter === void 0 ? void 0 : (ref1 = resultFilter.filter) === null || ref1 === void 0 ? void 0 : ref1.priceLte),
                min: Number(resultFilter === null || resultFilter === void 0 ? void 0 : (ref2 = resultFilter.filter) === null || ref2 === void 0 ? void 0 : ref2.priceGte)
            }
        };
    } catch (error) {
        logger.error(error);
        return {
            products: []
        };
    }
};
// fetch data for default block page (brand & seller page)
const fetchSingleDataBlockSSRFromDiscoveryV2 = async function(context, block) {
    let includeFilter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, optionalSortingParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const { req , query  } = context;
    const { tenantEnv , location , isMobile  } = req;
    const { discoveryServiceV2 , discoveryHelper  } = new ServiceContainer(tenantEnv);
    const { sort , order  } = optionalSortingParams;
    try {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        const [{ products  }, resultFilter] = await Promise.all([
            discoveryServiceV2.search({
                page: parseInt((query.page || "1").toString()),
                pageSize: isMobile ? MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE : DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE,
                slug: block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : (ref1 = ref.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.filter, query)),
                sorting: convertToPayloadSorting(sort, order),
                location
            }),
            includeFilter ? await discoveryServiceV2.search({
                pageSize: 1,
                slug: block === null || block === void 0 ? void 0 : (ref4 = block.cookedData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : ref5.slug,
                filter: convertToPayloadFilter(block === null || block === void 0 ? void 0 : (ref6 = block.cookedData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.paramsObject) === null || ref7 === void 0 ? void 0 : ref7.filter),
                returnFilterable: [
                    "FILTER_TYPE_ATTRIBUTE",
                    "FILTER_TYPE_BRAND",
                    "FILTER_TYPE_PRICE",
                    "FILTER_TYPE_CLEARANCE", 
                ],
                location
            }) : {}, 
        ]);
        return {
            ssrProducts: (products || []).map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product)),
            filters: resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter,
            filterPrice: {
                max: Number((ref8 = resultFilter.filter) === null || ref8 === void 0 ? void 0 : ref8.priceLte),
                min: Number((ref9 = resultFilter.filter) === null || ref9 === void 0 ? void 0 : ref9.priceGte)
            }
        };
    } catch (error) {
        logger.error(error);
        return {};
    }
};
const fetchDataBlockSSR = async (context, blocks)=>{
    const simpleProductBlocks = blocks.filter((b)=>[
            BlockType.FLASH_SALE,
            BlockType.PROMOTE_SELLER,
            BlockType.BEST_SELLING_PRODUCT,
            BlockType.LIST_SKU_MOBILE,
            BlockType.MAIN_SKU_LIST,
            BlockType.COUNT_DOWN_PROMO_SKU,
            BlockType.HORIZONTAL_SKU_LIST, 
        ].includes(b.type) && b.itemType === BlockItemType.SKU);
    const partialRenderedBlocks = blocks.filter((b)=>[
            BlockType.COUNT_DOWN_PROMO_TAB_MOBILE,
            BlockType.COUNT_DOWN_PROMO_BIG_SKU,
            BlockType.LISTING_TAB, 
        ].includes(b.type));
    const { discoveryService , discoveryHelper  } = new ServiceContainer(context.req.tenantEnv);
    const mapProducts = await Promise.all([
        ...simpleProductBlocks.map(async (block)=>{
            const result = await fetchSingleDataBlockSSR(context, block);
            return {
                [block.id]: (result === null || result === void 0 ? void 0 : result.ssrProducts) || []
            };
        }),
        ...partialRenderedBlocks.map(async (block)=>{
            var ref;
            // paramObject contains: blockId, itemId and other filter of discovery
            const firstItem = block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref[0];
            const blockId = block === null || block === void 0 ? void 0 : block.id;
            const itemId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
            const paramsObject = firstItem === null || firstItem === void 0 ? void 0 : firstItem.paramsObject;
            if (!paramsObject || !blockId || !itemId) {
                return {};
            }
            const products = await discoveryService.search(_objectSpreadProps(_objectSpread({}, paramsObject), {
                itemsPerPage: 20,
                location: context.req.location
            })).then((res)=>{
                var ref;
                return (((ref = res.result) === null || ref === void 0 ? void 0 : ref.products) || []).map((product)=>discoveryHelper.cleanupDiscoverySearchProduct(product));
            }).catch((error)=>{
                logger.error(error);
                return [];
            });
            return {
                ["".concat(blockId, "_").concat(itemId)]: products
            };
        }), 
    ]);
    return mapProducts.filter(Boolean).reduce((acc, curr)=>_objectSpread({}, acc, curr), {});
};
const fetchDataBlockSSRFromDiscoveryV2 = async (context, blocks)=>{
    const { discoveryHelper , discoveryServiceV2  } = new ServiceContainer(context.req.tenantEnv);
    const simpleProductBlocks = blocks.filter((b)=>[
            BlockType.FLASH_SALE,
            BlockType.PROMOTE_SELLER,
            BlockType.BEST_SELLING_PRODUCT,
            BlockType.LIST_SKU_MOBILE,
            BlockType.MAIN_SKU_LIST,
            BlockType.COUNT_DOWN_PROMO_SKU,
            BlockType.HORIZONTAL_SKU_LIST, 
        ].includes(b.type) && b.itemType === BlockItemType.SKU);
    const partialRenderedBlocks = blocks.filter((b)=>[
            BlockType.COUNT_DOWN_PROMO_TAB_MOBILE,
            BlockType.COUNT_DOWN_PROMO_BIG_SKU,
            BlockType.LISTING_TAB, 
        ].includes(b.type));
    const mapProducts = await Promise.all([
        ...simpleProductBlocks.map(async (block)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            const products = await discoveryServiceV2.search({
                slug: block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : (ref1 = ref.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.filter, context.query)),
                sorting: convertToPayloadSorting(context.query.sort || (block === null || block === void 0 ? void 0 : (ref4 = block.cookedData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sorting) === null || ref6 === void 0 ? void 0 : ref6.sort), context.query.order || (block === null || block === void 0 ? void 0 : (ref7 = block.cookedData) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.paramsObject) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sorting) === null || ref9 === void 0 ? void 0 : ref9.order)),
                pageSize: context.req.tenantEnv.isMobile ? MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE : SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE
            }).then((res)=>{
                return ((res === null || res === void 0 ? void 0 : res.products) || []).map((p)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(p));
            }).catch((error)=>{
                logger.error("[discovery-v2]", error);
                return [];
            });
            return {
                [block.id]: products
            };
        }),
        ...partialRenderedBlocks.map(async (block)=>{
            var ref;
            // paramObject contant: blockId, itemId and other filter of discovery
            const firstItem = block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref[0];
            const blockId = block === null || block === void 0 ? void 0 : block.id;
            const itemId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
            const paramsObject = firstItem === null || firstItem === void 0 ? void 0 : firstItem.paramsObject;
            if (!paramsObject || !blockId || !itemId) {
                return {};
            }
            try {
                const result = await discoveryServiceV2.search(_objectSpreadProps(_objectSpread({}, paramsObject), {
                    pageSize: 20,
                    location: context.req.location
                }));
                const products = ((result === null || result === void 0 ? void 0 : result.products) || []).map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product));
                return {
                    ["".concat(blockId, "_").concat(itemId)]: products
                };
            } catch (error) {
                logger.error(error);
                return {};
            }
        }), 
    ]);
    return mapProducts.filter(Boolean).reduce((acc, curr)=>Object.assign(acc || {}, curr), {});
};
const getBlockDomId = (block)=>block.label ? (0,_teko_slug__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(block.label) : "".concat(block.name, "-").concat(block.id);


/***/ }),

/***/ 30468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uD": function() { return /* binding */ useDiscovery_useDiscoveryProduct; },
  "b9": function() { return /* binding */ useDiscovery_useDiscoverySearch; },
  "nC": function() { return /* binding */ useInfiniteSearch; },
  "yz": function() { return /* binding */ useDiscovery_usePersonalizeBlocks; },
  "lR": function() { return /* binding */ useRecommendationComboDetail; },
  "jG": function() { return /* binding */ useRecommendationCombosData; },
  "mF": function() { return /* binding */ useRecommendationProductsData; },
  "Rx": function() { return /* binding */ useSearch; },
  "TA": function() { return /* binding */ useDiscovery_useSkus; }
});

// UNUSED EXPORTS: useInfiniteDiscoverySearch

// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-63a52198c3/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(93369);
// EXTERNAL MODULE: ./helpers/block.ts
var block = __webpack_require__(97441);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(43015);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(27890);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(34090);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(23357);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-63a52198c3/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/infinite/dist/index.esm.js
var dist_index_esm = __webpack_require__(62176);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js
var index_es = __webpack_require__(31260);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(41713);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/types.es.js
var types_es = __webpack_require__(89172);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/hooks.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearch = (discoveryService, params, location, options) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const _b = options || {}, {
    transformProduct = (data2) => data2
  } = _b, swrConfigs = __objRest(_b, [
    "transformProduct"
  ]);
  const keyAPI = (0,helpers_es/* getKeyAPI */.jG)(params, discoveryService.getBaseUrl());
  const normalizedParams = (0,helpers_es/* normalizePageBuilderToDiscoveryParams */.nS)(searchParams);
  const { data, error } = (0,index_esm/* default */.ZP)(keyAPI, async () => {
    const { sellerIds } = params;
    let newSellerIds = sellerIds;
    if (Array.isArray(sellerIds) && typeof sellerIds[0] === "number") {
      newSellerIds = sellerIds.map((id) => id.toString());
    }
    const response = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      sellerIds: newSellerIds,
      location
    }));
    return __spreadProps(__spreadValues({}, response), {
      result: __spreadProps(__spreadValues({}, response.result), {
        products: response.result.products.map(transformProduct)
      })
    });
  }, __spreadProps(__spreadValues({}, swrConfigs), {
    revalidateOnFocus: false
  }));
  const result = data == null ? void 0 : data.result;
  return {
    result: {
      products: (result == null ? void 0 : result.products) || [],
      filters: (result == null ? void 0 : result.filter) || {},
      pagination: (data == null ? void 0 : data.pagination) || {},
      cookedFilters: (0,helpers_es/* cookFilter */.BR)(result == null ? void 0 : result.filter, normalizedParams, result == null ? void 0 : result.masterCategories)
    },
    isLoading: !params ? false : !error && !data,
    isError: error
  };
};
const useInfiniteDiscoverySearch = (discoveryService, params, options) => {
  var _c;
  const _a = options || {}, {
    transformProduct = (data2) => data2
  } = _a, swrOptions = __objRest(_a, [
    "transformProduct"
  ]);
  const getKey = (pageIndex) => {
    const _a2 = params, rest2 = __objRest(_a2, ["page"]);
    return [rest2, pageIndex];
  };
  const convertSearchResponse = (response) => {
    var _a2, _b2;
    return {
      products: (((_a2 = response.result) == null ? void 0 : _a2.products) || []).map(transformProduct),
      suggestedKeyword: (_b2 = response.result) == null ? void 0 : _b2.suggestedKeyword,
      pagination: response.pagination
    };
  };
  const _b = (0,dist_index_esm/* default */.ZP)(getKey, async (_params, index) => {
    const response = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      page: parseInt(params.page || "1") + index
    }));
    return convertSearchResponse(response);
  }, swrOptions), { data, isValidating, size, setSize } = _b, rest = __objRest(_b, ["data", "isValidating", "size", "setSize"]);
  const isEmpty = data && data[0].products.length === 0;
  const hasMore = !(isEmpty || data && data[data.length - 1] && data[data.length - 1].products.length < (params.itemsPerPage || 10));
  const products = data ? data.reduce((acc, curr) => {
    return [...acc, ...curr.products];
  }, []) : [];
  const cookedData = data == null ? void 0 : data[0];
  const pagination = (data == null ? void 0 : data.length) ? (_c = data[data.length - 1]) == null ? void 0 : _c.pagination : void 0;
  return __spreadValues({
    isEmpty: !!isEmpty,
    isLoading: isValidating,
    hasMore,
    size,
    setSize,
    products,
    suggestedKeyword: cookedData == null ? void 0 : cookedData.suggestedKeyword,
    isValidating,
    pagination
  }, rest);
};
const useDiscoveryProduct = (discoveryService, sku, location) => {
  const { data, error } = useSWR(!!sku ? [`${discoveryService.getBaseUrl}/product`, sku, location] : null, async (_, sku2, location2) => {
    return await discoveryService.getProduct({
      sku: sku2,
      location: location2
    });
  });
  return {
    result: {
      product: data || null
    },
    isLoading: !error && !data,
    isError: !!error
  };
};
const usePersonalizeBlocks = (discoveryService, blockParams, transformBlock) => {
  var _a, _b;
  const { pageTypeEnum, category, seller, brand, sellerCategory } = blockParams;
  const params = (0,index_es/* cleanObject */.sW)(__spreadValues({}, blockParams));
  const conditionFetching = pageTypeEnum === types_es/* PageTypeEnum.HOME */.DZ.HOME || types_es/* PageTypeEnum.NOTIFICATION */.DZ.NOTIFICATION || pageTypeEnum === types_es/* PageTypeEnum.CATEGORY */.DZ.CATEGORY && (category || sellerCategory) || pageTypeEnum === types_es/* PageTypeEnum.BRAND */.DZ.BRAND && brand || pageTypeEnum === types_es/* PageTypeEnum.SELLER */.DZ.SELLER && seller;
  const { data, error } = (0,index_esm/* default */.ZP)(conditionFetching ? [`${discoveryService.getBaseUrl}/blocks`, JSON.stringify(params)] : null, async (_, paramsJson) => {
    return await discoveryService.getBlock(JSON.parse(paramsJson));
  }, {
    revalidateOnFocus: false
  });
  return {
    result: (((_a = data == null ? void 0 : data.result) == null ? void 0 : _a.blocks) || []).map(transformBlock),
    seoInfo: ((_b = data == null ? void 0 : data.result) == null ? void 0 : _b.seoInfo) || {},
    isLoading: !error && !data,
    isError: error
  };
};
const useSkus = (discoveryService, skus, location) => {
  const { data, error } = (0,index_esm/* default */.ZP)(skus ? [`${discoveryService.getBaseUrl}/products`, skus.join(","), location] : null, async (_, skus2, location2) => {
    return await discoveryService.getProductDetailBySkus({
      skus: skus2,
      location: location2
    });
  });
  return {
    result: {
      products: data || []
    },
    isLoading: !skus ? false : !error && !data,
    isError: error
  };
};



// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/v2/useDiscoverySearch.es.js
var useDiscoverySearch_es = __webpack_require__(45043);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/v2/useInfiniteDiscoverySearch.es.js
var useInfiniteDiscoverySearch_es = __webpack_require__(31844);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 8 modules
var context_es = __webpack_require__(46295);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 1 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(87679);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(85081);
;// CONCATENATED MODULE: ./hooks/useDiscovery.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const checkAlcoholicProduct = (product)=>{
    var ref, ref1;
    if (!product) return product;
    let sellerCatCodes = [];
    const categories = (product === null || product === void 0 ? void 0 : (ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.categories) || [];
    const masterCategories = (product === null || product === void 0 ? void 0 : (ref1 = product.productInfo) === null || ref1 === void 0 ? void 0 : ref1.masterCategories) || [];
    sellerCatCodes = categories.concat(masterCategories);
    return _objectSpreadProps(_objectSpread({}, product), {
        isAlcoholicCategory: sellerCatCodes.some((item)=>item.isAdult)
    });
};
const useDiscovery_useDiscoverySearch = (params, options)=>{
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const resultRef = (0,react.useRef)((options === null || options === void 0 ? void 0 : options.fallbackData) ? options === null || options === void 0 ? void 0 : options.fallbackData : {
        products: [],
        pagination: {
            totalItems: 0,
            totalPages: 1
        },
        filters: {}
    });
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService , discoveryPos365Service  } = (0,ServiceContext/* useServices */.Su)();
    const _ref = useDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, location, _objectSpreadProps(_objectSpread({}, options), {
        fallbackData: null,
        transformProduct: options === null || options === void 0 ? void 0 : options.transformProduct
    })), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const { isLoading  } = rest;
    const persistentData = isLoading ? resultRef.current : result;
    resultRef.current = persistentData;
    return _objectSpread({
        result: _objectSpreadProps(_objectSpread({}, persistentData), {
            products: persistentData === null || persistentData === void 0 ? void 0 : persistentData.products
        })
    }, rest);
};
const useDiscovery_useInfiniteDiscoverySearch = (params, options)=>{
    const { discoveryService , discoveryPos365Service  } = (0,ServiceContext/* useServices */.Su)();
    const _ref = useInfiniteDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, _objectSpreadProps(_objectSpread({}, options), {
        transformProduct: options === null || options === void 0 ? void 0 : options.transformProduct
    })), { products  } = _ref, rest = _objectWithoutProperties(_ref, [
        "products"
    ]);
    return _objectSpread({
        products
    }, rest);
};
const useDiscovery_useDiscoveryProduct = (sku, productId, options)=>{
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const productRef = (0,react.useRef)((options === null || options === void 0 ? void 0 : options.fallbackData) ? options === null || options === void 0 ? void 0 : options.fallbackData : null);
    const { data , mutate , error , isValidating: isLoading ,  } = (0,index_esm/* default */.ZP)(!!sku ? [
        sku,
        location,
        productId
    ] : null, async (sku, location, productId)=>{
        const params = {
            productId,
            sku,
            location
        };
        return discoveryService.getProduct(params);
    }, _objectSpreadProps(_objectSpread({}, options), {
        fallbackData: null,
        revalidateOnFocus: false
    }));
    const product = isLoading || !data ? productRef.current : data;
    productRef.current = product;
    return {
        result: {
            product: product && checkAlcoholicProduct(product)
        },
        isLoading,
        isError: !!error,
        mutate
    };
};
const useDiscovery_usePersonalizeBlocks = (blockParams)=>{
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return usePersonalizeBlocks(discoveryService, blockParams, block/* transformBlock */.Ot);
};
const useDiscovery_useSkus = (skus)=>{
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return useSkus(discoveryService, skus, location);
};
const useRecommendationProductsData = (sku)=>{
    var ref;
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku ? [
        "".concat(discoveryService.getBaseUrl, "/products_recommendation"),
        sku
    ] : null, async (_, sku)=>{
        return await discoveryService.getRecommendationProducts(sku);
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            productSets: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.productSets) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationCombosData = (sku)=>{
    var ref;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku ? [
        "".concat(discoveryService.getBaseUrl, "/products_combo"),
        sku,
        location
    ] : null, async (_, sku, location)=>{
        return await discoveryService.getRecommendationCombos(sku, {
            location
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            combos: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.combos) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationComboDetail = function(payloadCombo) {
    let call = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const skus = ((payloadCombo === null || payloadCombo === void 0 ? void 0 : payloadCombo.comboLineItems) || []).map((el)=>el.sku);
    const { data , error  } = (0,index_esm/* default */.ZP)(payloadCombo && call ? [
        "".concat(discoveryService.getBaseUrl, "/detail-combo"),
        JSON.stringify(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            location
        })), 
    ] : null, (_)=>{
        return discoveryService.getDetailComboRecommendation(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            location
        })).then((res)=>{
            var ref;
            return res === null || res === void 0 ? void 0 : (ref = res.result) === null || ref === void 0 ? void 0 : ref.combo;
        });
    }, {
        revalidateOnFocus: false
    });
    const reorderProductInCombo = ()=>{
        if (!data) return null;
        const { products  } = data;
        const newProducts = skus.map((el)=>{
            const product = products.find((p)=>p.product.productInfo.sku === el);
            return product;
        });
        return _objectSpreadProps(_objectSpread({}, data), {
            products: newProducts
        });
    };
    return {
        result: {
            combo: reorderProductInCombo()
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useSearch = (params, fallbackData, options)=>{
    const { isMobile , contactLink , allowAddToCartFromListing , isDisplayUom  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.a)();
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: allowAddToCartFromListing,
        cartV2,
        frames
    };
    // eslint-disable-next-line no-undef
    const transformProduct = (0,react.useCallback)((product)=>{
        return transformProductWhenUserUnder18(discoveryHelper.createHandleEventAndCtaButton(product, _objectSpread({}, discoveryCleanUpConfig)));
    }, [
        JSON.stringify(cartV2.flattenItems),
        authLoading
    ]);
    if (!flags.epic_ecom_472) {
        var ref;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { result , isError , isLoading  } = useDiscovery_useDiscoverySearch(params, _objectSpread({
            transformProduct: (product)=>discoveryHelper.cleanupDiscoverySearchProduct(product, _objectSpread({}, discoveryCleanUpConfig)),
            fallbackData: _objectSpread({}, fallbackData)
        }, options));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return {
            result: _objectSpreadProps(_objectSpread({}, result), {
                products: result === null || result === void 0 ? void 0 : (ref = result.products) === null || ref === void 0 ? void 0 : ref.map(transformProduct)
            }),
            isError,
            isLoading,
            transformProduct
        };
    } else {
        var ref1;
        const defaultFallbackData = {
            products: [],
            pagination: {
                totalItems: 0,
                totalPages: 1
            },
            filters: {}
        };
        //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const resultRef = (0,react.useRef)(fallbackData ? fallbackData : defaultFallbackData);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { error , loading , result: result1  } = (0,useDiscoverySearch_es/* useDiscoverySearchV2 */.t)(discoveryServiceV2, _objectSpread({}, params), _objectSpreadProps(_objectSpread({
            transform: (data)=>{
                var ref;
                return {
                    products: (data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig)))) || [],
                    filters: data === null || data === void 0 ? void 0 : data.filter,
                    pagination: {
                        totalItems: data.total,
                        totalPages: Math.ceil(data.total / (data.pageSize || isMobile ? search/* MOBILE_ITEM_PER_PAGE_IN_LISTING_PAGE */.YH : search/* DESKTOP_ITEM_PER_PAGE_IN_LISTING_PAGE */.BW))
                    },
                    cookedFilters: {}
                };
            }
        }, options), {
            // disable most of revalidating mechanisms
            revalidateOnFocus: false,
            shouldRetryOnError: false
        }));
        const persistentData = loading ? resultRef.current : result1 || defaultFallbackData;
        resultRef.current = persistentData;
        return {
            isError: !!error,
            isLoading: loading || false,
            result: _objectSpreadProps(_objectSpread({}, persistentData), {
                products: persistentData === null || persistentData === void 0 ? void 0 : (ref1 = persistentData.products) === null || ref1 === void 0 ? void 0 : ref1.map(transformProduct)
            }),
            transformProduct
        };
    }
};
const useInfiniteSearch = (params, fallbackData, options)=>{
    const { isDisplayUom , contactLink , allowAddToCartFromListing  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.a)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: allowAddToCartFromListing,
        cartV2,
        frames
    };
    // eslint-disable-next-line no-undef
    const transformProduct = (0,react.useCallback)((product)=>{
        return transformProductWhenUserUnder18(discoveryHelper.createHandleEventAndCtaButton(product, _objectSpread({}, discoveryCleanUpConfig)));
    }, [
        JSON.stringify(cartV2.flattenItems),
        authLoading
    ]);
    if (!flags.epic_ecom_472) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const _ref = useDiscovery_useInfiniteDiscoverySearch(params, _objectSpread({
            fallbackData: [
                {
                    products: (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.products) || [],
                    pagination: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.pagination
                }, 
            ],
            transformProduct: (product)=>discoveryHelper.cleanupDiscoverySearchProduct(product, _objectSpread({}, discoveryCleanUpConfig)),
            revalidateOnFocus: false
        }, options)), { products , size , setSize  } = _ref, rest = _objectWithoutProperties(_ref, [
            "products",
            "size",
            "setSize"
        ]);
        return _objectSpread({
            products: products === null || products === void 0 ? void 0 : products.map(transformProduct),
            size,
            onNextPage: ()=>setSize(size + 1)
        }, rest);
    } else {
        const _ref1 = (0,useInfiniteDiscoverySearch_es/* useInfiniteDiscoverySearchV2 */.x)(discoveryServiceV2, _objectSpread({}, params), {
            transform: (data)=>{
                var ref;
                return {
                    products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig))),
                    total: data.total
                };
            },
            fallbackData: [
                {
                    products: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.products,
                    total: 0
                }, 
            ]
        }), { data , loadmore , loading: isLoading  } = _ref1, rest1 = _objectWithoutProperties(_ref1, [
            "data",
            "loadmore",
            "loading"
        ]);
        const products1 = (data === null || data === void 0 ? void 0 : data.map((el)=>el.products || []).flat()) || [];
        return _objectSpread({
            products: products1 === null || products1 === void 0 ? void 0 : products1.map(transformProduct),
            onNextPage: loadmore,
            isLoading
        }, rest1);
    }
};


/***/ }),

/***/ 87679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useHandlerUnderEighteenYearOld; }
});

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(23357);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 8 modules
var context_es = __webpack_require__(46295);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
;// CONCATENATED MODULE: ./constants/index.ts







const INTERNAL_REQUEST_TIMEOUT_MS = 2000;
const OVER_18_YEAR_OLD_IMAGE = "https://lh3.googleusercontent.com/5mBwEcEB9rlGJSzrG1DBkiiuwCAwo0oGgjanB_wk3uP8jG-AERDd8buJQ19fmHCTOhA8GxFqV7dZlZhGJfixDlVFjMxNHvLufg"; // please do not export ibank from here
 // it would affect server code
 // export * from './ibank';

;// CONCATENATED MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const useHandlerUnderEighteenYearOld = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isBot  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { user , loading: authLoading  } = (0,context_es/* useAuth */.a)();
    const { handleUnder18  } = props;
    // EPIC-315: effect replace images when user is under 18 years old
    const convertProduct = (0,react.useCallback)((product)=>{
        var ref;
        const { addToCart  } = product;
        const emptyImages = (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.map((image)=>_objectSpreadProps(_objectSpread({}, image), {
                src: ""
            }))) || [];
        // if bot or product doesn't has adult category, no need to check age
        if (!flags.epic_ecom_315 || isBot || !(0,confirm18YearsOld/* isAdultCategoryProduct */.C2)(product.categories)) return {
            images: (product === null || product === void 0 ? void 0 : product.images) || [],
            imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || "",
            actionReady: true,
            addToCart
        };
        // if isn't serverless, no need to check age
        if (!(0,helpers/* isServerless */.ep)() || authLoading) {
            return {
                images: emptyImages,
                imageUrl: "",
                actionReady: false
            };
        } else {
            const requireCheckAge = (0,confirm18YearsOld/* requiredConfirm18YearsOld */.bO)(user);
            if (!requireCheckAge) {
                return {
                    images: (product === null || product === void 0 ? void 0 : product.images) || [],
                    imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || "",
                    actionReady: true,
                    addToCart
                };
            } else {
                var ref1;
                handleUnder18 === null || handleUnder18 === void 0 ? void 0 : handleUnder18();
                return {
                    images: (product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1.map((image)=>_objectSpreadProps(_objectSpread({}, image), {
                            src: OVER_18_YEAR_OLD_IMAGE
                        }))) || [],
                    imageUrl: OVER_18_YEAR_OLD_IMAGE,
                    actionReady: false
                };
            }
        }
    }, [
        user,
        authLoading,
        isBot
    ]);
    const transformProductWhenUserUnder18 = (0,react.useCallback)((product)=>{
        // if bot or product doesn't has adult category, no need to check age
        if (!flags.epic_ecom_315 || isBot || !product.isAlcoholicCategory) return _objectSpread({}, product);
        // if isn't serverless, no need to check age
        if (!(0,helpers/* isServerless */.ep)() || authLoading) {
            return _objectSpreadProps(_objectSpread({}, product), {
                imageUrl: "",
                // Hidden all button in this case
                addToCart: undefined,
                ctaButton: undefined,
                contactButton: undefined
            });
        } else {
            const requireCheckAge = (0,confirm18YearsOld/* requiredConfirm18YearsOld */.bO)(user);
            if (!requireCheckAge) {
                return _objectSpread({}, product);
            } else {
                handleUnder18 === null || handleUnder18 === void 0 ? void 0 : handleUnder18();
                return _objectSpreadProps(_objectSpread({}, product), {
                    imageUrl: OVER_18_YEAR_OLD_IMAGE,
                    // Hidden all button in this case
                    addToCart: undefined,
                    ctaButton: undefined,
                    contactButton: undefined
                });
            }
        }
    }, [
        user,
        authLoading,
        isBot
    ]);
    return {
        convertProduct,
        transformProductWhenUserUnder18
    };
};


/***/ })

}]);